import { IPoint } from '../struck';
import { IImageProps } from './image-layer';

export interface IBackgroundGradientProps {
    colors: {
        color: string;
        value: number;
    }[];
    angle: number;
    type?: number;
    point?: IPoint;
}

export interface IShaderInfoProps {
    backgroundColor: string;
    shaderUrl: string;
    speed: number;
    position: { x: number; y: number };
    color: string;
}

export enum DynamicType {
    Shader = 'shader',
    CSS = 'css',
    Video = 'video',
    Webp = 'webp',
}

export interface IDynamicInfoProps {
    screenshotUrl: string;
    hidden: boolean;
    shaderInfo?: IShaderInfoProps;
    name: string;
    dynamicType: DynamicType;
    enableBGColor?: boolean;
}

export interface IBackgroundLayerProps extends IImageProps {
    backgroundColor: string;
    backgroundGradient: IBackgroundGradientProps | null;
    // type和id没有 为什么加这个？
    type?: string;
    id?: number;
    dynamicInfo?: IDynamicInfoProps;
}
